import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiImportData,
  ApiImportDataType,
  ApiImportFieldPreview,
  ApiImportParse,
  ApiImportParseColumn,
  ApiImportParseFieldPayload,
  ApiImportPayloadSave,
  ApiImportPreviewOverview,
  ApiImportResult,
} from "@/types/import-data.types.ts";

export const apiImportData = {
  getAll: () => {
    return api.get<ApiImportData[]>(`/api/v1/data-import/get_all`);
  },
  preview: (fileUuid: string) => {
    return api.post<ApiImportPreviewOverview>(`/api/v1/data-import/preview`, {
      file_uuid: fileUuid,
    });
  },
  parse: (importId: number) => {
    return api.post<ApiImportParse>(`/api/v1/data-import/parse`, {
      import_id: importId,
    });
  },
  parseByType: (importId: number, importType: ApiImportDataType, tableId?: number | null) => {
    return api.post<ApiImportParse>(`/api/v1/data-import/parse-by-type`, {
      import_id: importId,
      import_type: importType,
      ...(importType === ApiImportDataType.custom_table && tableId ? { table_id: tableId } : {}),
    });
  },
  parseField: (payload: ApiImportParseFieldPayload) => {
    return api.post<ApiImportParseColumn>(`/api/v1/data-import/parse-field`, payload);
  },
  previewField: (importId: number, columnIndex: number) => {
    return api.post<ApiImportFieldPreview>(`/api/v1/data-import/field-preview`, {
      import_id: importId,
      column_index: columnIndex,
    });
  },
  save: (payload: ApiImportPayloadSave) => {
    return api.post<ApiOperationResult>(`/api/v1/data-import/save`, payload);
  },
  start: (importId: number) => {
    return api.post<ApiOperationResult>(`/api/v1/data-import/start`, { import_id: importId });
  },
  result: (importId: number) => {
    return api.get<ApiImportResult>(`/api/v1/data-import/${importId}/result`);
  },
  delete: (importId: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/data-import/${importId}`);
  },
};
